var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var QuestionSortable_1;
import React from 'react';
import { observer } from 'mobx-react';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import { Aspect_ } from '../../../components/actor/Aspect_';
import { SortableList_ } from './SortableList_';
import { Actor_ } from '../../../components/actor/Actor_';
import { head } from '../../../utils/helper/lodash_replacements';
import { memoize } from '../../../utils/mobx/decorators/memoize';
let QuestionSortable_ = QuestionSortable_1 = class QuestionSortable_ extends React.PureComponent {
    get droppables() {
        const { layout } = this.props;
        if (layout === 'droppables2ToNGrouped') {
            return this.droppables2ToNGrouped;
        }
        return this.droppablesSeparate;
    }
    get droppables2ToNGrouped() {
        const firstList = head(this.props.question.sortableStore.sortableLists);
        return (React.createElement(React.Fragment, null,
            React.createElement(Aspect_, { aspect: firstList.ownAspect.outer },
                React.createElement(Droppable, { droppableId: firstList.id_string, direction: firstList.direction }, (provided, snapshot) => React.createElement(SortableList_, { sortableList: firstList, provided: provided, snapshot: snapshot }))),
            React.createElement(Aspect_, { aspect: this.props.question.ownAspect.droppables }, this.props.question.sortableStore.sortableLists.slice(1).map(sortableList => (React.createElement(Aspect_, { aspect: sortableList.ownAspect.outer, key: sortableList.id },
                React.createElement(Aspect_, { aspect: sortableList.ownAspect.heading }),
                React.createElement(Droppable, { droppableId: sortableList.id_string, direction: sortableList.direction }, (provided, snapshot) => React.createElement(SortableList_, { sortableList: sortableList, provided: provided, snapshot: snapshot }))))))));
    }
    get droppablesSeparate() {
        return this.props.question.sortableStore.sortableLists.map(sortableList => (React.createElement(Droppable, { droppableId: sortableList.id_string, direction: sortableList.direction }, (provided, snapshot) => React.createElement(SortableList_, { sortableList: sortableList, provided: provided, snapshot: snapshot }))));
    }
    render() {
        const { question } = this.props;
        // MOBX: SortableList_ is needed to react to variable changes in render prop!
        return (React.createElement(DragDropContext, { onDragStart: question.sortableEvents.onDragStart, onDragUpdate: question.sortableEvents.onDragUpdate, onDragEnd: question.sortableEvents.onDragEnd },
            React.createElement(Aspect_, { aspect: question.inner },
                React.createElement(Aspect_, { aspect: question.ownAspect.moves, templateComponent: QuestionSortable_1.templateComponent },
                    "Noch ",
                    question.sortableMoves.movesRemaining,
                    " mal schieben"),
                React.createElement(Actor_, { actor: question.questionPart }),
                this.droppables)));
    }
    static get templateComponent() {
        return React.createElement("div", { style: { position: 'absolute', top: 0 } });
    }
};
__decorate([
    memoize
], QuestionSortable_, "templateComponent", null);
QuestionSortable_ = QuestionSortable_1 = __decorate([
    observer
], QuestionSortable_);
export { QuestionSortable_ };
